import { UrlProperties } from "@/types";

export const getEditorUrlParam = (key: string): string => {
  const urlParams = window.location.search.substring(1).split("&");
  let paramValue = "";
  for (let i = 0; i < urlParams.length; i++) {
    const parameter = urlParams[i].split("=");
    if (parameter[0] === key) {
      paramValue = parameter[1];
    }
  }
  return paramValue;
};

const isCustom = (pathName: string[]): boolean => {
  const isCustom = pathName.find((section) => section === "custom");

  if (isCustom) return true;
  else return false;
};

const isTemplate = (): boolean => {
  if (getEditorUrlParam("template_id").length) return true;
  else return false;
};

const isArtwork = (): boolean => {
  if (getEditorUrlParam("hash").length) return true;
  else return false;
};

const labelTypes = ["blank", "flyer", "magnet", "printed", "rollprinted"];
const getLabelType = (pathName: string[]): string => {
  let labelType = "";
  pathName.forEach((section) => {
    if (labelTypes.includes(section)) {
      labelType = section;
    }
  });

  return labelType;
};

const getLabelId = (pathName: string[]): string => {
  let labelId = "";
  if (!isCustom(pathName)) {
    labelId = pathName[pathName.length - 1];
  }

  return labelId;
};

export const getUrlProperties = (): UrlProperties => {
  const pathName = window.location.pathname.split("/");

  const UrlProperties: UrlProperties = {
    isCustom: isCustom(pathName),
    isTemplate: isTemplate(),
    isCreatingTemplate: false,
    isArtwork: isArtwork(),
    labelType: getLabelType(pathName),
    labelId: getLabelId(pathName),
    quickLink: getEditorUrlParam("quick_link"),
    corners: getEditorUrlParam("corners"),
  };

  return UrlProperties;
};
